import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Welcome from './Welcome';
import Session from './Session';
import Event from './Event';
import PreviewEnd from './PreviewEnd';
import PreviewStart from './PreviewStart';

const Body: React.FC = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Welcome />}></Route>
        <Route path="/s/:reference" element={<Session />}></Route>
        <Route path="/w/:reference" element={<Event />}></Route>
        <Route
          path="/p/:reference"
          element={<Session isPreview={true} />}
        ></Route>
        <Route path="/p/:reference/start" element={<PreviewStart />}></Route>
        <Route path="/p/:reference/end" element={<PreviewEnd />}></Route>
      </Routes>
    </>
  );
};

export default Body;
